import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import CookiePreferences, { CookiePreferences as CookiePreferencesType } from './CookiePreferences';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    const allAccepted: CookiePreferencesType = {
      necessary: true,
      analytics: true,
      marketing: true,
    };
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookiePreferences', JSON.stringify(allAccepted));
    setIsVisible(false);
  };

  const handleDecline = () => {
    const onlyNecessary: CookiePreferencesType = {
      necessary: true,
      analytics: false,
      marketing: false,
    };
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookiePreferences', JSON.stringify(onlyNecessary));
    setIsVisible(false);
  };

  const handleSavePreferences = (preferences: CookiePreferencesType) => {
    localStorage.setItem('cookieConsent', 'custom');
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 animate-in slide-in-from-bottom duration-500">
        <div className="container mx-auto max-w-6xl">
          <div className="bg-card/95 backdrop-blur-lg border border-border rounded-2xl shadow-elegant p-4 sm:p-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div className="flex-1 pr-4">
                <h3 className="text-lg font-semibold mb-2">
                  <span className="relative inline-block">
                    <span className="relative z-10">{t('cookies.title')}</span>
                    <span className="absolute bottom-1 left-0 w-full h-3 bg-accent/30 -z-0"></span>
                  </span>
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {t('cookies.description')}
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto">
                <Button
                  variant="ghost"
                  onClick={() => setShowPreferences(true)}
                  className="w-full sm:w-auto"
                >
                  {t('cookies.preferences')}
                </Button>
                <Button
                  variant="outline"
                  onClick={handleDecline}
                  className="w-full sm:w-auto"
                >
                  {t('cookies.decline')}
                </Button>
                <Button
                  onClick={handleAccept}
                  className="w-full sm:w-auto"
                >
                  {t('cookies.accept')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CookiePreferences
        open={showPreferences}
        onOpenChange={setShowPreferences}
        onSave={handleSavePreferences}
      />
    </>
  );
};

export default CookieBanner;
